module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"see_all_reviews":"查看全部商品評論","create_review":"撰寫商品評論"}}')
  delete Component.options._Ctor
}
